type OrderableMap = { position?: number; label?: string };

export default function compareMapsByPosition(a: OrderableMap, b: OrderableMap) {
	return (a.position ?? 0) - (b.position ?? 0)
		|| (a.label || '').localeCompare(b.label || '', 'fr', { numeric: true });
}
